import React from "react";
import Navbar from './Navbar.js';
import first from './Images/first.jpg';
import second from './Images/second.png';
import third from './Images/third.png';
import fourth from './Images/fourth.jpg';
import './App.css';

function Transmission(){
    return(
        <>
            <Navbar />
            <section id="transmission">
                <div className="container">
                <h1 className="transmission-h1" data-aos="zoom-in-right">
                    Transmission
                </h1>
                <div className="row trans-row">
                    <div className="col-md-3 col-sm-12 col-12 col-lg-3 trans" data-aos="flip-left">
                        <div className="trans-1">
                        <h4 className="trans-h4">
                            update #009
                        </h4>
                        <h4 className="trans-p">
                            Roseus
                        </h4>
                        <img src={first} className="trans-img"></img>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-12 col-12 col-lg-3 trans trans-2" data-aos="flip-left">
                    <div className="trans-1">
                    <h4 className="trans-h4">
                            update #008
                        </h4>
                        <h4 className="trans-p">
                            Prasinos
                        </h4>
                        <img src={second} className="trans-img"></img>
                    </div>
                    </div>
                    <div className="col-md-3 col-sm-12 col-12 col-lg-3 trans trans-3" data-aos="flip-left">
                    <div className="trans-1">
                    <h4 className="trans-h4">
                            update #007
                        </h4>
                        <h4 className="trans-p">
                            Mauve
                        </h4>
                        <img src={third} className="trans-img"></img>
                    </div>
                    </div>
                    
                </div>


                <div className="row trans-row row-2">
                    <div className="col-md-3 col-sm-12 col-12 col-lg-3 trans" data-aos="flip-left">
                        <div className="trans-1">
                        <h4 className="trans-h4">
                            update #009
                        </h4>
                        <h4 className="trans-p">
                            Roseus
                        </h4>
                        <img src={fourth} className="trans-img"></img>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-12 col-12 col-lg-3 trans trans-2" data-aos="flip-left">
                    <div className="trans-1">
                    <h4 className="trans-h4">
                            update #008
                        </h4>
                        <h4 className="trans-p">
                            Prasinos
                        </h4>
                        <img src={first} className="trans-img"></img>
                    </div>
                    </div>
                    <div className="col-md-3 col-sm-12 col-12 col-lg-3 trans trans-3" data-aos="flip-left">
                    <div className="trans-1">
                    <h4 className="trans-h4">
                            update #007
                        </h4>
                        <h4 className="trans-p">
                            Mauve
                        </h4>
                        <img src={second} className="trans-img"></img>
                    </div>
                    </div>
                    
                </div>
                </div>
            </section>
        </>
    );
}

export default Transmission;